import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_LOCATION_SUCCESS,
  FETCH_LOCATION_SUCCESS,
  GET_LOCATION_SUCCESS,
  SAVE_LOCATION_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchFilter, fetchStart, fetchSuccess } from "./Common";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_LOCATION_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_LOCATION_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_LOCATION_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_LOCATION_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { location } = store.getState();
      const { query } = location;
      const response = await axios.get(`/location?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { location } = store.getState();
      const { query } = location;
      const response = await axios.get(`/location/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {

      // let formData = new FormData();
      // const documentData = [];
      // payload.documents && payload.documents.map((item, index) => {
      //   formData.append('files', item.file);
      //   let data = {...item};
      //   delete data.file;
      //   documentData.push(data)
      // });

      // formData.append('documentData', JSON.stringify(documentData));

      // Object.keys(payload).forEach(key => {
      //   if (key === 'documents') {
      //     return
      //   }

      //   formData.append(key, payload[key]);
      // });
      const response = await axios.post(`/location`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
      }

      if (!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/location');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      // let formData = new FormData();

      // const documentData = [];
      // const documentIds = [];
      // payload.documents.map((item, index) => {
      //   if (!item.file.path) {
      //     formData.append('files', item.file);
      //     let data = {...item};
      //     delete data.file;
      //     documentData.push(data)
      //   } else {
      //     documentIds.push(item._id);
      //   }
      // });

      // formData.append('documentData', JSON.stringify(documentData));
      // formData.append('documentIds', JSON.stringify(documentIds));

      // Object.keys(payload).forEach(key => {
      //   if (key === 'documents') {
      //     return
      //   }

      //   formData.append(key, payload[key]);
      // });

      const response = await axios.put(`/location/${id}`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      history.push('/location');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/location/${id}`);
      // console.log("response****:", response.data);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.delete(`/location/${id}`);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
